import {
  IconButton,
  Pagination,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import SvgIcon from "../../components/Images/SvgIcon";
import moment from "moment";
import {
  startLoader,
  stopLoader,
  showToast,
  open_dialog,
} from "../../lib/global";
import { DELETE_SLIDE_MODEL } from "../../lib/constant";
import { breadcrumbAction } from "../../redux/actions/config.action";
import { getAllSlides, updateSlideById } from "../../redux/actions/slides.action";
import ablity from "../../helpers/abilityGuard";
import { IOSSwitch } from "../../components/switch/IOSSwitch";

function Slides() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [slidesData, setSlidesData] = useState([]);
  const [offset, setOffset] = useState(0);
  const [limit] = useState(10);

  const fetchSlides = () => {
    startLoader();
    dispatch(getAllSlides({ limit, offset }))
      .then((res) => {
        if (res && res.data && res.data.status === 200) {
          setSlidesData(res.data.data || []);
        } else {
          setSlidesData([]);
        }
        setTimeout(() => stopLoader(), 500);
      })
      .catch((err) => {
        console.error("Error fetching slides:", err);
        setSlidesData([]);
        stopLoader();
      });
  };

  useEffect(() => {
    const breadcrumb = [{ label: "Slides", url: null }];
    dispatch(breadcrumbAction(breadcrumb));
  }, [dispatch]);

  useEffect(() => {
    fetchSlides();
  }, [offset]);

  const handlePageChange = (event, value) => {
    setOffset(value - 1);
  };

  const handleStatusToggle = (id, currentStatus) => {
    startLoader();
    dispatch(updateSlideById(id, { isActive: !currentStatus }))
      .then((res) => {
        stopLoader();
        showToast("Status updated successfully", "success");
        fetchSlides();
      })
      .catch((err) => {
        stopLoader();
        console.error("Error updating status:", err);
        showToast("Failed to update status", "error");
      });
  };

  const handleDeleteClick = (id) => {
    open_dialog(DELETE_SLIDE_MODEL, {
      onSubmit: fetchSlides,
      id,
    });
  };

  return (
    <React.Fragment>
      <div className="card mx-3 p-3 shadow-sm border-0">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 className="font-weight-bold mb-1">HERO CAROUSEL SLIDES</h5>
            <p className="text-muted mb-0 small">
              Manage homepage main hero carousel slideshow elements.
            </p>
          </div>
          <div>
            {ablity({ model: "Slides", action: "create" }) === 1 && (
              <button
                type="button"
                onClick={() => history.push("/slides/add")}
                className="btn btn-dark px-4 py-2 text-nowrap rounded-lg shadow-sm"
              >
                + Add Slide
              </button>
            )}
          </div>
        </div>

        {/* Info Box */}
        <div className="alert alert-light border d-flex justify-content-between align-items-center mb-4 p-3 rounded-lg">
          <div>
            <span className="badge text-uppercase mb-1 px-2 py-1" style={{ backgroundColor: "#495057", color: "#ffffff" }}>
              HOMEPAGE SLIDER
            </span>
            <div className="font-weight-bold text-dark mt-1">
              Top horizontal hero banners which auto-rotate on the customer main screen
            </div>
          </div>
          <div className="text-right">
            <div className="small text-muted font-weight-bold">Expected Image Size</div>
            <div className="text-primary font-weight-bold h6 mb-0">
              902 x 360 px
            </div>
          </div>
        </div>

        <TableContainer className="border rounded-lg">
          <Table sx={{ minWidth: 650 }} stickyHeader aria-label="sticky table">
            <TableHead className="bg-light">
              <TableRow>
                <TableCell className="th_cell font-weight-bold" align="left" style={{ width: "60px" }}>
                  No.
                </TableCell>
                <TableCell className="th_cell font-weight-bold" align="left">
                  Slide Image
                </TableCell>
                <TableCell className="th_cell font-weight-bold" align="left">
                  Alt Text
                </TableCell>
                <TableCell className="th_cell font-weight-bold" align="left">
                  Target Link
                </TableCell>
                <TableCell className="th_cell font-weight-bold" align="center" style={{ width: "110px" }}>
                  Sort Order
                </TableCell>
                <TableCell className="th_cell font-weight-bold" align="center">
                  Schedule Period
                </TableCell>
                <TableCell className="th_cell font-weight-bold" align="center" style={{ width: "100px" }}>
                  Active
                </TableCell>
                <TableCell className="th_cell font-weight-bold text-center" align="center" style={{ width: "120px" }}>
                  Action
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {slidesData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} align="center" className="py-5 text-muted">
                    <h5>No slides found</h5>
                    <p className="mb-0 text-secondary">Click the "+ Add Slide" button to create one.</p>
                  </TableCell>
                </TableRow>
              ) : (
                slidesData.map((row, i) => (
                  <TableRow key={row.id || i} hover>
                    <TableCell align="left" className="td_cell align-middle">
                      {offset * limit + (i + 1)}
                    </TableCell>
                    <TableCell align="left" className="td_cell align-middle">
                      <img
                        src={row.image || "/icons/upload_icon.svg"}
                        alt="preview"
                        className="rounded border pointer py-1"
                        style={{ maxWidth: "160px", maxHeight: "80px", objectFit: "contain" }}
                      />
                    </TableCell>
                    <TableCell align="left" className="td_cell align-middle font-weight-bold">
                      {row.alt || "-"}
                    </TableCell>
                    <TableCell align="left" className="td_cell align-middle text-primary">
                      <code className="text-break">{row.href || "-"}</code>
                    </TableCell>
                    <TableCell align="center" className="td_cell align-middle font-weight-bold">
                      {row.sortOrder !== undefined ? row.sortOrder : "-"}
                    </TableCell>
                    <TableCell align="center" className="td_cell align-middle">
                      <div className="small">
                        <span className="text-success font-weight-bold">Start:</span>{" "}
                        {row.startDate ? moment(row.startDate).format("DD MMM YYYY, HH:mm") : "-"}
                      </div>
                      <div className="small mt-1">
                        <span className="text-danger font-weight-bold">End:</span>{" "}
                        {row.endDate ? moment(row.endDate).format("DD MMM YYYY, HH:mm") : "-"}
                      </div>
                    </TableCell>
                    <TableCell align="center" className="td_cell align-middle">
                      {ablity({ model: "Slides", action: "update" }) === 1 ? (
                        <IOSSwitch
                          checked={row.isActive || false}
                          onChange={() => handleStatusToggle(row.id, row.isActive)}
                        />
                      ) : (
                        <span className={`badge ${row.isActive ? "bg-success" : "bg-danger"} text-white`}>
                          {row.isActive ? "Active" : "Inactive"}
                        </span>
                      )}
                    </TableCell>
                    <TableCell align="center" className="td_cell align-middle">
                      <div className="d-flex justify-content-center align-items-center">
                        {ablity({ model: "Slides", action: "update" }) === 1 && (
                          <IconButton
                            className="pointer px-2"
                            onClick={() => history.push(`/slides/edit/${row.id}`)}
                          >
                            <SvgIcon src="/icons/edit_icon.svg" alt="edit icon" />
                          </IconButton>
                        )}
                        {ablity({ model: "Slides", action: "delete" }) === 1 && (
                          <IconButton
                            className="pointer px-2"
                            onClick={() => handleDeleteClick(row.id)}
                          >
                            <SvgIcon src="/icons/delete_icon.svg" alt="delete icon" />
                          </IconButton>
                        )}
                      </div>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>

        {slidesData.length > 0 && (
          <div className="d-flex justify-content-end align-items-center mt-3 pr-2">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil((slidesData.length || 0) / limit)}
                shape="rounded"
                size="small"
                onChange={handlePageChange}
              />
            </Stack>
          </div>
        )}
      </div>
    </React.Fragment>
  );
}

export default Slides;
